// extracted by mini-css-extract-plugin
export default {"container":"LastMatchesResults_container__GYmwj","win":"LastMatchesResults_win__64ryJ","lose":"LastMatchesResults_lose__tEUgx","draw":"LastMatchesResults_draw__K6BJT"};